import { Store } from "~/bff/types/Store";
import { ClickCollectStatuses } from "~/constants/data-layer";

export const clickAndCollectStoreStatusGA = (
  store?: Store | null,
): string | boolean => {
  if (!store?.geomodifier) {
    return ClickCollectStatuses.storeNotYetSelected;
  } else {
    return !!store?.clickAndCollectStore;
  }
};
